import { AgreementModelInterface, UpdateAgreementInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const getAgreements: () => Promise<AgreementModelInterface[]> = (): Promise<AgreementModelInterface[]> => api.get('agreements');

export const updateAgreements: (data: UpdateAgreementInterface[]) => Promise<void>
= (data: UpdateAgreementInterface[]): Promise<void> => api.post('agreements', data);
